export function setDisponibilidad(state, disponibilidad) {
  state.disponibilidad_S = disponibilidad.disponibilidad_S;
  state.disponibilidad_M = disponibilidad.disponibilidad_M;
  state.disponibilidad_L = disponibilidad.disponibilidad_L;
  state.disponibilidad_XL = disponibilidad.disponibilidad_XL;
 
}

export function setDisponibilidad_S(state, disponibilidad) {
  state.disponibilidad_S = disponibilidad;
}

export function setDisponibilidad_M(state, disponibilidad) {
  state.disponibilidad_M = disponibilidad;
}

export function setDisponibilidad_L(state, disponibilidad) {
  state.disponibilidad_L = disponibilidad;
}

export function setDisponibilidad_XL(state, disponibilidad) {
  state.disponibilidad_XL = disponibilidad;
}

export function setSelecBici(state, bici) {
    switch (bici.talla) {
    case "S":
      const index = state.disponibilidad_S.findIndex((r) => r.id == bici.id);
      if (index != -1) {
        state.disponibilidad_S[index].seleccion = !state.disponibilidad_S[index].seleccion;
      }
      break;
    case "M":
        const index1 = state.disponibilidad_M.findIndex((r) => r.id == bici.id);
      if (index1 != -1) {
        state.disponibilidad_M[index1].seleccion = !state.disponibilidad_M[index1].seleccion;
      }
      break;

    case "L":
        const index2 = state.disponibilidad_L.findIndex((r) => r.id == bici.id);
      if (index2 != -1) {
        state.disponibilidad_L[index2].seleccion = !state.disponibilidad_L[index2].seleccion;
      }
      break;

    case "XL":
        const index3 = state.disponibilidad_XL.findIndex((r) => r.id == bici.id);
      if (index3 != -1) {
        state.disponibilidad_XL[index3].seleccion = !state.disponibilidad_XL[index3].seleccion;
      }
      break;

    default:
      break;
  }
}

export function updateSeleccionadasEditar(state, bicis) {
  
  bicis.forEach(bici => {
    const index = state.disponibilidad_S.findIndex((r) => r.id == bici.id);
    if (index != -1) {
      state.disponibilidad_S[index].seleccion = true;
      state.disponibilidad_S[index].ocupada = false;
    }

    const index1 = state.disponibilidad_M.findIndex((r) => r.id == bici.id);
    if (index1 != -1) {
      state.disponibilidad_M[index1].seleccion = true;
      state.disponibilidad_M[index1].ocupada = false;
    }

    const index2 = state.disponibilidad_L.findIndex((r) => r.id == bici.id);
    if (index2 != -1) {
      state.disponibilidad_L[index2].seleccion = true;
      state.disponibilidad_L[index2].ocupada = false;
    }

    const index3 = state.disponibilidad_XL.findIndex((r) => r.id == bici.id);
    if (index3 != -1) {
      state.disponibilidad_XL[index3].seleccion = true;
      state.disponibilidad_XL[index3].ocupada = false;
    }

    
  });

}

